/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/terms/csm.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core

// App components
import { Link } from '@client/components';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- TABS
----------------------------------*/
const TermsTabs = ({
  current
}: {
  current: 'tools' | 'marketplace' | 'csm' | 'teamLeader' | 'businessPartner' | 'dealPartner' | 'ambassadors';
}) => {
  const base = 'px-4 py-2 rounded-lg text-sm font-semibold transition-colors';
  const active = 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow';
  const inactive = 'text-slate-700 hover:text-orange-600 hover:bg-orange-50';
  return <div className="flex flex-wrap items-center gap-2 bg-orange-50 border border-orange-100 rounded-xl p-2">
            <Link to="/terms" className={`${base} ${current === 'tools' ? active : inactive}`}>
                Tools
            </Link>
            <Link to="/terms/marketplace" className={`${base} ${current === 'marketplace' ? active : inactive}`}>
                Marketplace
            </Link>
            <Link to="/terms/csm" className={`${base} ${current === 'csm' ? active : inactive}`}>
                CSM
            </Link>
            <Link to="/terms/team-leader" className={`${base} ${current === 'teamLeader' ? active : inactive}`}>
                Team Leader
            </Link>
            <Link to="/terms/business-partner" className={`${base} ${current === 'businessPartner' ? active : inactive}`}>
                Business Partner
            </Link>
            <Link to="/terms/deal-partner" className={`${base} ${current === 'dealPartner' ? active : inactive}`}>
                Deal Partner
            </Link>
            <Link to="/terms/ambassadors" className={`${base} ${current === 'ambassadors' ? active : inactive}`}>
                Ambassadors
            </Link>
        </div>;
};

/*----------------------------------
- PAGE: CSM TERMS
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/terms/csm', { ...({
  static: {
    refresh: '1h',
    urls: ['/terms/csm']
  }
}), ...{ filepath: "/app/client/pages/terms/csm.tsx", sourceLocation: { line: 54, column: 1 }, id: "terms_csm" } }, null, ({}) => {
  const placeholderClassName = 'font-bold text-slate-900';
  return <Page mainClassName="pt-28 pb-20 px-6 lg:px-8 bg-gradient-to-br from-orange-50 via-white to-pink-50">
            <div className="max-w-[920px] mx-auto">
                <div className="mb-6">
                    <TermsTabs current="csm" />
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10">
                    <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent mb-6">
                        Customer Success Manager Agreement
                    </h1>

                    <div className="prose prose-slate max-w-none">
                        <header className="mb-6">
                            <p className="text-slate-700 mb-0">
                                This Customer Success Manager Agreement (hereinafter referred to as the “Agreement”) is
                                entered into as of <span className={placeholderClassName}>[DATE]</span>, between:
                            </p>
                        </header>

                        <section className="not-prose border border-slate-200 rounded-xl p-4 bg-slate-50 mb-8" aria-label="Parties">
                            <dl className="text-slate-800">
                                <dt className="font-bold mt-0">Cross Path Network Ltd</dt>
                                <dd className="ml-0 mt-1">Registered in England with registration number 13863925</dd>
                                <dd className="ml-0 mt-1">
                                    Address: Unit 01.12, 1st Floor, 30 Norman Road, London, SE10 9QX, United Kingdom
                                </dd>
                                <dd className="ml-0 mt-1">(“Cross Path” or the “Company”)</dd>

                                <dt className="font-bold mt-4">Customer Success Manager (CSM)</dt>
                                <dd className="ml-0 mt-1">
                                    Name of the CSM: <span className={placeholderClassName}>[NAME]</span>
                                </dd>
                                <dd className="ml-0 mt-1">
                                    Address of the CSM: <span className={placeholderClassName}>[ADDRESS]</span>
                                </dd>
                                <dd className="ml-0 mt-1">(“CSM”)</dd>
                            </dl>
                            <p className="text-slate-600 mt-3 mb-0">Collectively referred to as “the Parties”.</p>
                        </section>

                        <section className="mt-0">
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                1. Purpose of the Agreement
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The purpose of this Agreement is to define the terms and conditions under which the CSM
                                manages client relationships and coordinates sourcing activities for recruitment
                                mandates signed by Cross Path.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                2. Nature of the Collaboration
                            </h2>
                            <p className="text-slate-700 mb-0">
                                The relationship established by this Agreement is that of independent contractors.
                                Nothing in this Agreement shall be construed to create a relationship of employer and
                                employee, principal and agent, or joint venture between the Parties.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                3. Responsibilities of the CSM
                            </h2>
                            <p className="text-slate-700 mb-4">The CSM agrees to:</p>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.1 Client Communication and Candidate Presentation
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Present candidates to clients and provide detailed information about their profiles,
                                    qualifications, and suitability for the role.
                                </li>
                                <li>Respond to client questions and inquiries regarding presented candidates.</li>
                                <li>
                                    Ensure regular communication and updates with clients regarding candidate progress
                                    throughout the recruitment process.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.2 Candidate Selection and Validation
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Review and validate candidates presented by sourcers from the Cross Path network.
                                </li>
                                <li>
                                    Select the most suitable candidates to present to the client based on job
                                    requirements and client feedback.
                                </li>
                                <li>
                                    Remain impartial and professional in candidate presentation, ensuring fair treatment
                                    of all candidates regardless of who sourced them (including candidates the CSM may
                                    have sourced themselves).
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.3 Sourcer Coordination and Quality Control
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Identify and recruit suitable sourcers from the Cross Path network to work on
                                    assigned recruitment mandates.
                                </li>
                                <li>Coordinate and supervise sourcers working on the assigned mandates.</li>
                                <li>
                                    Serve as the sole point of communication between clients and sourcers (no direct
                                    communication between clients and sourcers).
                                </li>
                                <li>Control the number of active sourcers on each mission to maintain quality.</li>
                                <li>
                                    Activate or deactivate sourcers based on their performance (automatic deactivation
                                    after 14 days without candidate presentation, or manual deactivation at CSM&apos;s
                                    discretion).
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.4 Interview Coordination and Supervision
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>Organize and schedule interviews between clients and candidates when necessary.</li>
                                <li>
                                    Supervise interviews and provide support to ensure a professional process, when
                                    appropriate.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                3.5 Job Description Management
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Update and refine job descriptions published on the Cross Path platform based on
                                    client feedback and evolving requirements.
                                </li>
                                <li>Ensure job descriptions accurately reflect client needs and expectations.</li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.6 Platform and Tools Usage</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Use Cross Path&apos;s tools and platform subject to the applicable access terms.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">3.7 Professional Conduct</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Maintain professionalism, integrity, and impartiality in all client interactions and
                                    candidate evaluations.
                                </li>
                                <li>Comply with all applicable anti-bribery and anti-corruption laws.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                4. Responsibilities of Cross Path
                            </h2>
                            <p className="text-slate-700 mb-4">Cross Path agrees to:</p>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Provide access to necessary tools for client and sourcer management, including CRM,
                                    ATS, and mission coordination features subject to the applicable access terms.
                                </li>
                                <li>Provide operational support for mandate execution.</li>
                                <li>Handle contract signing, invoicing, and payment collection from clients.</li>
                                <li>
                                    Calculate and distribute commissions in accordance with the terms specified in each
                                    recruitment mandate.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                5. Commission and Payment Terms
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.1 CSM Commission</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    The CSM shall be entitled to the commission share specified in each individual
                                    recruitment contract or mandate assignment.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.2 Multiple Role Cumulation</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    If the CSM is also acting as Business Partner, Team Leader, or Free Recruiter on the
                                    same mandate, commissions from multiple roles may be cumulated as specified in the
                                    individual mandate terms.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">5.3 Payment Conditions</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Commission payments will be made only after Cross Path has received the full amount
                                    due from the client, and provided no portion of that amount is subject to refund or
                                    reimbursement.
                                </li>
                                <li>
                                    The CSM acknowledges that no commission shall be payable for any mandate that does
                                    not result in a successful paid placement.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                6. Platform Access Terms
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">6.1 Access Requirement</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    The CSM must hold active platform access in order to act as a CSM and access the
                                    necessary client and sourcer management tools.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">6.2 Cumulative Access</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    If the CSM also holds Business Partner or Team Leader access, a single access
                                    agreement provides access to both their primary role functionalities (BP or TL) and
                                    CSM functionalities.
                                </li>
                                <li>
                                    If the CSM is solely a Free Recruiter (sourcer) who wishes to act as CSM, they must
                                    obtain access to CSM tools and functionalities.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">6.3 Access Terms</h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    The applicable commercial terms for access to the platform and tools are determined
                                    separately and may be modified by Cross Path with 30 days&apos; prior written notice.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                7. Removal from Specific Missions and Termination of CSM Status
                            </h2>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                7.1 Removal from Individual Missions
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Cross Path or the Business Partner/Team Leader who signed the client mandate
                                    reserves the right to remove the CSM from any specific recruitment mission at any
                                    time, for any reason, without prior notice.
                                </li>
                                <li>
                                    Such removal from a specific mission shall not affect the CSM&apos;s assignment to
                                    other ongoing missions or their general CSM status under this Agreement.
                                </li>
                                <li>
                                    No commission shall be due to the CSM for any mission from which they have been
                                    removed, unless otherwise agreed in writing.
                                </li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                7.2 Termination of CSM Status for Gross Misconduct
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-6">
                                <li>
                                    Cross Path reserves the right to unilaterally terminate the CSM&apos;s status and
                                    access to CSM functionalities in the event of gross misconduct, including but not
                                    limited to:
                                </li>
                                <li>Serious breach of confidentiality obligations;</li>
                                <li>Fraudulent activity or misrepresentation;</li>
                                <li>Violation of anti-bribery and anti-corruption laws;</li>
                                <li>Persistent failure to maintain professional standards;</li>
                                <li>Actions that damage Cross Path&apos;s reputation or client relationships;</li>
                                <li>Breach of impartiality obligations in candidate presentation.</li>
                            </ul>

                            <h3 className="text-lg font-semibold text-slate-900 mb-2">
                                7.3 Consequences of CSM Status Termination
                            </h3>
                            <ul className="list-disc pl-6 text-slate-700 mb-0">
                                <li>
                                    Upon termination of CSM status for gross misconduct, the CSM&apos;s subscription to
                                    the Cross Path platform shall not be renewed.
                                </li>
                                <li>
                                    Any commissions accrued prior to the termination date shall remain payable in
                                    accordance with Section 5, provided all payment conditions have been met.
                                </li>
                                <li>
                                    If the CSM also holds Business Partner or Team Leader status, Cross Path may, at its
                                    sole discretion, terminate those agreements as well in cases of gross misconduct.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                8. Confidentiality
                            </h2>
                            <p className="text-slate-700 mb-4">
                                8.1 The Parties agree to keep all confidential information obtained during the course of
                                this Agreement strictly confidential and not to disclose it to any third party during or
                                after the term of this Agreement.
                            </p>
                            <p className="text-slate-700 mb-0">
                                8.2 These confidentiality obligations shall survive the termination of this Agreement
                                indefinitely for as long as the Confidential Information remains non-public or
                                proprietary in nature.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                9. Duration and Termination
                            </h2>
                            <p className="text-slate-700 mb-2">
                                9.1 This Agreement shall remain in effect until terminated by either Party.
                            </p>
                            <p className="text-slate-700 mb-2">
                                9.2 Either Party may terminate this Agreement at any time by providing written notice to
                                the other Party.
                            </p>
                            <p className="text-slate-700 mb-2">
                                9.3 Any commissions accrued prior to termination shall remain payable in accordance with
                                the conditions set forth in Section 5. “Accrued” means that all conditions necessary for
                                payment have been satisfied.
                            </p>
                            <p className="text-slate-700 mb-0">
                                9.4 Termination of this Agreement does not affect the provisions of Section 7 regarding
                                removal from specific missions or termination of CSM status for gross misconduct.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                10. Governing Law and Jurisdiction
                            </h2>
                            <p className="text-slate-700 mb-4">
                                This Agreement and any dispute, claim, or obligation arising out of or in connection
                                with it shall be governed by and construed in accordance with English law.
                            </p>
                            <p className="text-slate-700 mb-0">
                                The Parties irrevocably agree to submit to the exclusive jurisdiction of the English
                                courts.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-2 border-t border-slate-200 pt-4">
                                11. Miscellaneous
                            </h2>
                            <p className="text-slate-700 mb-4">
                                The CSM must promptly report to Cross Path any improper request or activity that could
                                constitute bribery or corruption.
                            </p>
                            <p className="text-slate-700 mb-4">
                                Any amendment or modification to this Agreement must be made in writing and signed by
                                both Parties.
                            </p>
                            <p className="text-slate-700 mb-0">
                                IN WITNESS WHEREOF, the Parties have executed this Agreement as of the date first
                                written above.
                            </p>
                        </section>

                        {/* Signatures removed */}
                    </div>
                </div>
            </div>
        </Page>;
});
};
